import React from 'react';
import { X } from 'lucide-react';

const MedicineModal = ({ isOpen, onClose, isLoading, medicineFormData, setMedicineFormData, onSubmit }) => {
  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setMedicineFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="flex justify-between items-center px-6 py-4 border-b border-gray-200">
          <h2 className="text-lg font-semibold">MediScheduler</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-500 focus:outline-none"
            disabled={isLoading}
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <form onSubmit={onSubmit} className="px-6 py-4">
          <div className="space-y-6">
            <div>
              <label className="block text-sm font-medium text-gray-700">Morning</label>
              <div className="mt-2 flex items-center space-x-4">
                <input
                  type="checkbox"
                  name="morning"
                  id="morning"
                  checked={medicineFormData.morning}
                  onChange={handleInputChange}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  disabled={isLoading || medicineFormData.morning}
                />
                <input
                  type="text"
                  name="morning_comment"
                  id="morning_comment"
                  value={medicineFormData.morning_comment}
                  onChange={handleInputChange}
                  placeholder="Comment (optional)"
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  disabled={isLoading}
                />
                <span className="text-sm text-gray-500">
                  {medicineFormData.morning_time ? new Date(medicineFormData.morning_time).toLocaleTimeString() : '--:--'}
                </span>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Afternoon</label>
              <div className="mt-2 flex items-center space-x-4">
                <input
                  type="checkbox"
                  name="afternoon"
                  id="afternoon"
                  checked={medicineFormData.afternoon}
                  onChange={handleInputChange}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  disabled={isLoading || medicineFormData.afternoon}
                />
                <input
                  type="text"
                  name="afternoon_comment"
                  id="afternoon_comment"
                  value={medicineFormData.afternoon_comment}
                  onChange={handleInputChange}
                  placeholder="Comment (optional)"
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  disabled={isLoading}
                />
                <span className="text-sm text-gray-500">
                  {medicineFormData.afternoon_time ? new Date(medicineFormData.afternoon_time).toLocaleTimeString() : '--:--'}
                </span>
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">Night</label>
              <div className="mt-2 flex items-center space-x-4">
                <input
                  type="checkbox"
                  name="night"
                  id="night"
                  checked={medicineFormData.night}
                  onChange={handleInputChange}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                  disabled={isLoading || medicineFormData.night}
                />
                <input
                  type="text"
                  name="night_comment"
                  id="night_comment"
                  value={medicineFormData.night_comment}
                  onChange={handleInputChange}
                  placeholder="Comment (optional)"
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  disabled={isLoading}
                />
                <span className="text-sm text-gray-500">
                  {medicineFormData.night_time ? new Date(medicineFormData.night_time).toLocaleTimeString() : '--:--'}
                </span>
              </div>
            </div>
          </div>
          <div className="mt-6 flex justify-end space-x-3">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 flex items-center justify-center"
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <svg className="animate-spin h-5 w-5 mr-2 text-white" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Submitting...
                </>
              ) : (
                'Submit'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default MedicineModal;